/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addProfileFile } from '../fn/profile-file/add-profile-file';
import { AddProfileFile$Params } from '../fn/profile-file/add-profile-file';
import { BooleanResponse } from '../models/boolean-response';
import { deleteProfileFile } from '../fn/profile-file/delete-profile-file';
import { DeleteProfileFile$Params } from '../fn/profile-file/delete-profile-file';
import { ProfileFile } from '../models/profile-file';

@Injectable({ providedIn: 'root' })
export class ProfileFileService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `addProfileFile()` */
  static readonly AddProfileFilePath = '/rest/profile/{id}/file';

  /**
   * Add file (report or certificate) to profile.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addProfileFile()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  addProfileFile$Response(params: AddProfileFile$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileFile>> {
    return addProfileFile(this.http, this.rootUrl, params, context);
  }

  /**
   * Add file (report or certificate) to profile.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addProfileFile$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  addProfileFile(params: AddProfileFile$Params, context?: HttpContext): Observable<ProfileFile> {
    return this.addProfileFile$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProfileFile>): ProfileFile => r.body)
    );
  }

  /** Path part for operation `deleteProfileFile()` */
  static readonly DeleteProfileFilePath = '/rest/profile/{id}/file/{profileFileId}';

  /**
   * Delete uploaded file for profile.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteProfileFile()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteProfileFile$Response(params: DeleteProfileFile$Params, context?: HttpContext): Observable<StrictHttpResponse<BooleanResponse>> {
    return deleteProfileFile(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete uploaded file for profile.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteProfileFile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteProfileFile(params: DeleteProfileFile$Params, context?: HttpContext): Observable<BooleanResponse> {
    return this.deleteProfileFile$Response(params, context).pipe(
      map((r: StrictHttpResponse<BooleanResponse>): BooleanResponse => r.body)
    );
  }

}
